import PageLayout from './PageLayout';

export default function ProjectsPage() {
  return (
    <PageLayout title="Projects">
      <p>Projects coming soon.</p>
    </PageLayout>
  );
}
